import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export interface IDemoInteractionBlockerProps {}

export function DemoInteractionBlocker(props: IDemoInteractionBlockerProps) {
  const context = useSelector((state: any) => state.executor.context);
  if (context?.mode === 'demo' && process.env.REACT_APP_ENV !== 'development') {
    return <Container data-container="DemoInteractionBlocker"></Container>;
  }
  return <></>;
}
